export default __webpack_public_path__ + "static/media/100_6204.695682f5.jpg";